'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});


var Vue = require('vue');

Vue.component('tabbed-tab', {
    props: {
        header: { status: String },
        focus: { status: Boolean },
        name: { status: String }
    },
    data: function data() {
        return { active: false };
    },
    template: '<div v-if="active" class="u-tabbed-content"><slot></slot></div>'
});

exports.default = Vue.component('tabbed-view', {
    data: function data() {
        return {
            a: 1,
            prefixID: Math.floor(Math.random() * 100000).toString(36)
        };
    },
    computed: {
        tabs: function computedtabs() {
            return this.$children;
        }
    },
    mounted: function mounted() {
        this.setActiveCheck();
    },

    methods: {
        getActive: function getActive() {
            var foundChild = null;
            this.$children.forEach(function (child) {
                if (child.active) {
                    foundChild = child;
                }
            });

            return foundChild;
        },
        setActive: function setActive(c) {
            this.$children.forEach(function (child) {
                if (child !== c) {
                    child.active = false;
                }
            });
            c.active = true;

            this.a++;
            this.$emit('changed', c.name);
        },
        setActiveByName: function setActiveByName(name) {
            var _this = this;

            this.$children.forEach(function (child) {
                if (child.name === name) {
                    _this.setActive(child);
                }
            });
        },
        setActiveCheck: function setActiveCheck() {
            var _this2 = this;

            this.$children.forEach(function (t) {
                if (t.focus) {
                    _this2.setActive(t);
                }
            });
        }
    }
});


//////////////////
// WEBPACK FOOTER
// ./build/exports-loader.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/customized-core/utils/TabbedView.vue
// module id = cAE9
// module chunks = 1